'use strict';
exports.parse = require('htmlparser2').parseDocument;
exports.render = require('dom-serializer').default;
